// ============================================================================
// src/pointClos.js : le point qui vient d'être clos, et son décompte
// ============================================================================
// Recette de Pierre du 18/10/2026 (séance fictive « Vote Libre ») : « je n'ai
// plus le bouton pour afficher les résultats des scrutins ». La carte de
// l'onglet « En cours » de la console ne vivait que pour un scrutin OUVERT :
// à la clôture, elle disparaissait (« Aucun scrutin ouvert ») et, avec elle,
// « Publier », l'écran de salle et les exports. Le point qui vient d'être clos
// garde désormais sa place jusqu'à l'ouverture du suivant :
//   • dans la console (onglet « En cours ») : sa carte, pour publier ;
//   • sur l'écran de salle : ses résultats, une fois publiés ;
//   • dans l'espace du votant : son résultat, une fois publié.
// Une seule règle pour les trois, ici. Règles PURES.
// ============================================================================

/** Points sans résultat à publier : présentation, divers, atelier
 *  d'amendements (son texte est adopté par un scrutin à part). */
export const TYPES_SANS_RESULTAT = ["info", "divers", "amendement"];

/** L'heure d'une clôture : « JJ/MM/AAAA HH:MM:SS » (nowFull de la console)
 *  ou ISO (préparation des séances). 0 si illisible. */
export function instantDe(t) {
  if (!t) return 0;
  const s = String(t);
  const fr = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\D+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
  if (fr) {
    const [, j, m, a, h = "0", mi = "0", se = "0"] = fr;
    return new Date(Number(a), Number(m) - 1, Number(j), Number(h), Number(mi), Number(se)).getTime() || 0;
  }
  const iso = Date.parse(s);
  return Number.isFinite(iso) ? iso : 0;
}

/**
 * Le dernier point clos qui a un résultat, tant qu'aucun point n'est ouvert
 * (null sinon) : le plus tard clos, et à heure égale, le plus loin dans
 * l'ordre du jour.
 */
export function dernierPointClos(agenda) {
  const liste = Array.isArray(agenda) ? agenda.filter((s) => s && typeof s === "object") : [];
  if (liste.some((s) => s.status === "open")) return null;
  let retenu = null;
  let rang = -1;
  for (const s of liste) {
    if (s.status !== "closed" || TYPES_SANS_RESULTAT.includes(s.type)) continue;
    const t = instantDe(s.closedAt);
    if (t >= rang) { retenu = s; rang = t; }
  }
  return retenu;
}

/** Décompte d'un vote OUI / NON : votes portant un choix (lecture publique
 *  d'un scrutin publié). */
export function decompteOuiNon(votes) {
  const vs = Array.isArray(votes) ? votes : [];
  const n = (c) => vs.filter((v) => v && v.choice === c).length;
  return { oui: n("oui"), non: n("non"), abstention: n("abstention") };
}
